var map = {
	"./game-1/tutorial/elementary/desktop/1.png": 57024,
	"./game-1/tutorial/elementary/desktop/2.png": 93005,
	"./game-1/tutorial/elementary/desktop/3.png": 75333,
	"./game-1/tutorial/elementary/desktop/4.png": 38988,
	"./game-1/tutorial/elementary/desktop/5.png": 29525,
	"./game-1/tutorial/elementary/desktop/6.png": 81631,
	"./game-1/tutorial/elementary/mobile/1.png": 61140,
	"./game-1/tutorial/elementary/mobile/2.png": 73810,
	"./game-1/tutorial/elementary/mobile/3.png": 75225,
	"./game-1/tutorial/elementary/mobile/4.png": 29421,
	"./game-1/tutorial/elementary/mobile/5.png": 44743,
	"./game-1/tutorial/elementary/mobile/6.png": 35445,
	"./game-1/tutorial/high/desktop/1.png": 51794,
	"./game-1/tutorial/high/desktop/2.png": 16213,
	"./game-1/tutorial/high/desktop/3.png": 45430,
	"./game-1/tutorial/high/desktop/4.png": 47495,
	"./game-1/tutorial/high/desktop/5.png": 90978,
	"./game-1/tutorial/high/desktop/6.png": 12769,
	"./game-1/tutorial/high/mobile/1.png": 18638,
	"./game-1/tutorial/high/mobile/2.png": 79424,
	"./game-1/tutorial/high/mobile/3.png": 58310,
	"./game-1/tutorial/high/mobile/4.png": 70981,
	"./game-1/tutorial/high/mobile/5.png": 71242,
	"./game-1/tutorial/high/mobile/6.png": 69597,
	"./game-1/tutorial/middle/desktop/1.png": 44635,
	"./game-1/tutorial/middle/desktop/2.png": 38995,
	"./game-1/tutorial/middle/desktop/3.png": 67594,
	"./game-1/tutorial/middle/desktop/4.png": 19058,
	"./game-1/tutorial/middle/desktop/5.png": 70574,
	"./game-1/tutorial/middle/desktop/6.png": 85445,
	"./game-1/tutorial/middle/mobile/1.png": 59780,
	"./game-1/tutorial/middle/mobile/2.png": 82030,
	"./game-1/tutorial/middle/mobile/3.png": 70305,
	"./game-1/tutorial/middle/mobile/4.png": 14946,
	"./game-1/tutorial/middle/mobile/5.png": 1323,
	"./game-1/tutorial/middle/mobile/6.png": 44618,
	"./game-2/tutorial/elementary/desktop/1-1.png": 21772,
	"./game-2/tutorial/elementary/desktop/1.png": 1970,
	"./game-2/tutorial/elementary/desktop/2-1.png": 84471,
	"./game-2/tutorial/elementary/desktop/2.png": 74702,
	"./game-2/tutorial/elementary/desktop/3.png": 173,
	"./game-2/tutorial/elementary/desktop/4.png": 61665,
	"./game-2/tutorial/elementary/desktop/5.png": 15149,
	"./game-2/tutorial/elementary/mobile/1-1.png": 20136,
	"./game-2/tutorial/elementary/mobile/1.png": 33924,
	"./game-2/tutorial/elementary/mobile/2-1.png": 36266,
	"./game-2/tutorial/elementary/mobile/2.png": 72414,
	"./game-2/tutorial/elementary/mobile/3.png": 89055,
	"./game-2/tutorial/elementary/mobile/4.png": 93702,
	"./game-2/tutorial/elementary/mobile/5.png": 97091,
	"./game-2/tutorial/high/desktop/1.png": 46848,
	"./game-2/tutorial/high/desktop/2-1.png": 6589,
	"./game-2/tutorial/high/desktop/2.png": 75678,
	"./game-2/tutorial/high/desktop/3.png": 67235,
	"./game-2/tutorial/high/desktop/4.png": 3370,
	"./game-2/tutorial/high/mobile/1.png": 95083,
	"./game-2/tutorial/high/mobile/2-1.png": 9606,
	"./game-2/tutorial/high/mobile/2.png": 21917,
	"./game-2/tutorial/high/mobile/3.png": 93584,
	"./game-2/tutorial/high/mobile/4.png": 61034,
	"./game-2/tutorial/middle/desktop/1.png": 60485,
	"./game-2/tutorial/middle/desktop/2-1.png": 15417,
	"./game-2/tutorial/middle/desktop/2.png": 9247,
	"./game-2/tutorial/middle/desktop/3.png": 60732,
	"./game-2/tutorial/middle/desktop/4.png": 42489,
	"./game-2/tutorial/middle/mobile/1.png": 77014,
	"./game-2/tutorial/middle/mobile/2-1.png": 23138,
	"./game-2/tutorial/middle/mobile/2.png": 3538,
	"./game-2/tutorial/middle/mobile/3.png": 72255,
	"./game-2/tutorial/middle/mobile/4.png": 45082,
	"./game-3/tutorial/elementary/desktop/1.png": 83361,
	"./game-3/tutorial/elementary/desktop/2.png": 7172,
	"./game-3/tutorial/elementary/desktop/3.png": 74310,
	"./game-3/tutorial/elementary/desktop/4.png": 2545,
	"./game-3/tutorial/elementary/desktop/5.png": 83060,
	"./game-3/tutorial/elementary/desktop/6.png": 42603,
	"./game-3/tutorial/elementary/desktop/7.png": 657,
	"./game-3/tutorial/elementary/mobile/1.png": 33749,
	"./game-3/tutorial/elementary/mobile/2.png": 82425,
	"./game-3/tutorial/elementary/mobile/3.png": 35628,
	"./game-3/tutorial/elementary/mobile/4.png": 48194,
	"./game-3/tutorial/elementary/mobile/5.png": 60295,
	"./game-3/tutorial/elementary/mobile/6.png": 97421,
	"./game-3/tutorial/elementary/mobile/7.png": 74683,
	"./game-3/tutorial/high/desktop/1.png": 68589,
	"./game-3/tutorial/high/desktop/2.png": 96815,
	"./game-3/tutorial/high/desktop/3.png": 36059,
	"./game-3/tutorial/high/desktop/4.png": 1612,
	"./game-3/tutorial/high/desktop/5.png": 85314,
	"./game-3/tutorial/high/mobile/1.png": 93505,
	"./game-3/tutorial/high/mobile/2.png": 63095,
	"./game-3/tutorial/high/mobile/3.png": 97919,
	"./game-3/tutorial/high/mobile/4.png": 52113,
	"./game-3/tutorial/high/mobile/5.png": 84640,
	"./game-3/tutorial/middle/desktop/1.png": 54614,
	"./game-3/tutorial/middle/desktop/2.png": 96571,
	"./game-3/tutorial/middle/desktop/3.png": 77239,
	"./game-3/tutorial/middle/desktop/4.png": 15938,
	"./game-3/tutorial/middle/desktop/5.png": 61881,
	"./game-3/tutorial/middle/mobile/1.png": 67471,
	"./game-3/tutorial/middle/mobile/2.png": 95646,
	"./game-3/tutorial/middle/mobile/3.png": 36130,
	"./game-3/tutorial/middle/mobile/4.png": 74896,
	"./game-3/tutorial/middle/mobile/5.png": 98235,
	"./game-4/tutorial/elementary/desktop/1.png": 62427,
	"./game-4/tutorial/elementary/desktop/2.png": 78468,
	"./game-4/tutorial/elementary/desktop/3.png": 62255,
	"./game-4/tutorial/elementary/desktop/4.png": 93440,
	"./game-4/tutorial/elementary/desktop/5.png": 19076,
	"./game-4/tutorial/elementary/mobile/1.png": 98865,
	"./game-4/tutorial/elementary/mobile/2.png": 97983,
	"./game-4/tutorial/elementary/mobile/3.png": 64506,
	"./game-4/tutorial/elementary/mobile/4.png": 47208,
	"./game-4/tutorial/elementary/mobile/5.png": 6473,
	"./game-4/tutorial/high/desktop/1.png": 88671,
	"./game-4/tutorial/high/desktop/2.png": 99202,
	"./game-4/tutorial/high/desktop/3.png": 76543,
	"./game-4/tutorial/high/desktop/4.png": 86058,
	"./game-4/tutorial/high/desktop/5.png": 41245,
	"./game-4/tutorial/high/mobile/1.png": 85613,
	"./game-4/tutorial/high/mobile/2.png": 23113,
	"./game-4/tutorial/high/mobile/3.png": 32952,
	"./game-4/tutorial/high/mobile/4.png": 87740,
	"./game-4/tutorial/high/mobile/5.png": 20109,
	"./game-4/tutorial/middle/desktop/1.png": 69290,
	"./game-4/tutorial/middle/desktop/2.png": 87342,
	"./game-4/tutorial/middle/desktop/3.png": 66598,
	"./game-4/tutorial/middle/desktop/4.png": 71971,
	"./game-4/tutorial/middle/desktop/5.png": 59366,
	"./game-4/tutorial/middle/mobile/1.png": 83406,
	"./game-4/tutorial/middle/mobile/2.png": 73211,
	"./game-4/tutorial/middle/mobile/3.png": 34626,
	"./game-4/tutorial/middle/mobile/4.png": 64906,
	"./game-4/tutorial/middle/mobile/5.png": 48321,
	"./game-5/tutorial/high/desktop/1.png": 43673,
	"./game-5/tutorial/high/desktop/2.png": 68807,
	"./game-5/tutorial/high/desktop/3.png": 39797,
	"./game-5/tutorial/high/mobile/1.png": 57402,
	"./game-5/tutorial/high/mobile/2.png": 18538,
	"./game-5/tutorial/high/mobile/3.png": 85414,
	"./game-5/tutorial/middle/desktop/1.png": 83762,
	"./game-5/tutorial/middle/desktop/2.png": 32393,
	"./game-5/tutorial/middle/desktop/3.png": 84910,
	"./game-5/tutorial/middle/mobile/1.png": 96286,
	"./game-5/tutorial/middle/mobile/2.png": 48658,
	"./game-5/tutorial/middle/mobile/3.png": 86317,
	"./game-6/tutorial/elementary/desktop/1.png": 81282,
	"./game-6/tutorial/elementary/desktop/2.png": 93538,
	"./game-6/tutorial/elementary/desktop/3.png": 22408,
	"./game-6/tutorial/elementary/desktop/4.png": 72895,
	"./game-6/tutorial/elementary/desktop/5.png": 71055,
	"./game-6/tutorial/elementary/mobile/1.png": 78211,
	"./game-6/tutorial/elementary/mobile/2.png": 80132,
	"./game-6/tutorial/elementary/mobile/3.png": 78173,
	"./game-6/tutorial/elementary/mobile/4.png": 43014,
	"./game-6/tutorial/elementary/mobile/5.png": 76465,
	"./game-6/tutorial/high/desktop/1.png": 95867,
	"./game-6/tutorial/high/desktop/2.png": 58759,
	"./game-6/tutorial/high/desktop/3.png": 32641,
	"./game-6/tutorial/high/desktop/4.png": 53682,
	"./game-6/tutorial/high/desktop/5.png": 22670,
	"./game-6/tutorial/high/mobile/1.png": 90747,
	"./game-6/tutorial/high/mobile/2.png": 65089,
	"./game-6/tutorial/high/mobile/3.png": 9285,
	"./game-6/tutorial/high/mobile/4.png": 65029,
	"./game-6/tutorial/high/mobile/5.png": 44652,
	"./game-6/tutorial/middle/desktop/1.png": 51931,
	"./game-6/tutorial/middle/desktop/2.png": 40969,
	"./game-6/tutorial/middle/desktop/3.png": 5082,
	"./game-6/tutorial/middle/desktop/4.png": 17776,
	"./game-6/tutorial/middle/desktop/5.png": 38386,
	"./game-6/tutorial/middle/mobile/1.png": 34016,
	"./game-6/tutorial/middle/mobile/2.png": 35597,
	"./game-6/tutorial/middle/mobile/3.png": 90582,
	"./game-6/tutorial/middle/mobile/4.png": 17355,
	"./game-6/tutorial/middle/mobile/5.png": 69497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3574;